<template>
	<div>
		<p>
			<span v-html="selectRandom([
				`The outcomes for ${getHeader()} are: ${getOutcomes()}.`,
				`In the context of ${getHeader()}, the following outcomes were noted: ${getOutcomes()}.`
			])">
			</span>
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputStudyOutcome",
	mixins: [OutputMixin],
	methods: {
		joinArrayWithAnd(array) {
			if (array.length === 1) return array[0];
			if (array.length === 2) return `${array[0]} and ${array[1]}`;
			return `${array.slice(0, -1).join(", ")}, and ${array[array.length - 1]}`;
		},

		// Header Formatting
		getHeader() {
			const headers = this.$tera.project.detableSudyOutcome.headers.map(
				(header) => header.field
			);
			return this.joinArrayWithAnd(headers);
		},

		// For extracting and formatting outcomes
		getOutcomes() {
			const rows = this.$tera.project.detableSudyOutcome.rows;
			const headers = this.$tera.project.detableSudyOutcome.headers.map(
				(header) => header.field
			);
			const outcomeMap = {};

			headers.forEach((header) => {
				const filteredValues = rows
					.map((row) => row[header])
					.filter((value) => value && value.trim());
				outcomeMap[header] = filteredValues;
			});
			const outcomes = Object.entries(outcomeMap)
				.filter(([, values]) => values.length > 0)
				.map(([key, values]) => {
					return `for ${key}: ${this.joinArrayWithAnd(values)}`;
				});
			return outcomes.length ? this.joinArrayWithAnd(outcomes) : "No outcomes available.";
		}
	}
};
</script>

<style scoped></style>
